import { Link, useLocation } from 'react-router-dom';
import { Drawer } from 'antd';
import { StyledBottomMenu, StyledDropdownMenu } from './styles';
import {
  menuItems,
  extraMenuItems,
  affiliateMenuItems,
} from '@src/constants/MenuItems';
import { More } from 'iconsax-react';
import { selectLayout } from '@src/store/layout/layoutSlice';
import { useSelector } from 'react-redux';
import React, { useEffect, useRef, useState } from 'react';
import { selectProfile } from '@src/store/profile/profileSlice';

export function BottomMenu() {
  const location = useLocation();
  const layout = useSelector(selectLayout);
  const drawerRef = useRef<HTMLDivElement>(null);
  const moreButtonRef = useRef<HTMLAnchorElement>(null);
  const profile = useSelector(selectProfile);

  const [selectedExtraKey, setSelectedExtraKey] = useState<string | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const itemsToUse = profile?.isAffiliate
    ? [...extraMenuItems, ...affiliateMenuItems]
    : extraMenuItems;

  useEffect(() => {
    if (!drawerOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        drawerRef.current &&
        !drawerRef.current.contains(event.target as Node) &&
        moreButtonRef.current &&
        !moreButtonRef.current.contains(event.target as Node)
      ) {
        setDrawerOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [drawerOpen]);

  const selectedKey = location.pathname.split('/').filter(Boolean).pop() || '';
  const isMoreMenuSelected = extraMenuItems.some(
    (item) => item.key === selectedKey
  );

  useEffect(() => {
    if (isMoreMenuSelected) {
      setSelectedExtraKey(selectedKey);
    }
  }, [isMoreMenuSelected, selectedKey]);

  const selectedKeys = isMoreMenuSelected
    ? ['more', selectedExtraKey || selectedKey]
    : selectedKey
      ? [selectedKey]
      : [];

  const handleExtraItemClick = (key: string) => {
    setSelectedExtraKey(key);
    setDrawerOpen(false);
  };
  const handleMoreClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDrawerOpen(!drawerOpen);
  };

  const menuItemsMapped = [
    ...menuItems.map((item) => ({
      key: item.key,
      label: (
        <Link
          to={item.url}
          onClick={() => setSelectedExtraKey(null)}
          className='flex py-4 flex-col items-center text-xs'
        >
          {item.icon}
          {item.label}
        </Link>
      ),
    })),
    {
      key: 'more',
      label: (
        <Link
          ref={moreButtonRef}
          to=''
          onClick={(e) => handleMoreClick(e)}
          className='flex py-4 flex-col items-center text-xs'
        >
          <More variant='Bulk' size={24} />
          <span>More</span>
        </Link>
      ),
    },
  ];

  return (
    <>
      <div
        className='fixed bottom-0 left-0 w-full bg-wl-background flex justify-around py-2 md:hidden rounded-tl-2xl rounded-tr-2xl  shadow-[0_-4px_10px_rgba(0,0,0,0.1)]'
        style={{ zIndex: 9999 }}
      >
        <StyledBottomMenu
          selectedKeys={selectedKeys}
          className='flex justify-around'
          items={menuItemsMapped}
          themeMode={layout.theme}
        />
      </div>

      <Drawer
        className='bottom-menu-drawer rounded-tl-2xl rounded-tr-2xl !bg-wl-background !text-wl-on-background shadow-[0_-4px_10px_rgba(0,0,0,0.1)]'
        placement='bottom'
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        closable={false}
        mask={false}
        getContainer={false}
        styles={{ wrapper: { boxShadow: 'none' } }}
        style={{
          position: 'absolute',
          bottom: '70px',
          width: '100%',
          height: '280px',
          border: 'none',
        }}
      >
        <div ref={drawerRef}>
          <StyledDropdownMenu themeMode={layout.theme}>
            {itemsToUse.map((item) => (
              <Link
                key={item.key}
                to={item.url}
                onClick={() => handleExtraItemClick(item.key)}
                className={`flex !py-4 ${
                  selectedExtraKey === item.key
                    ? 'rounded-lg bg-black !text-white dark:bg-white dark:!text-black'
                    : ''
                }`}
              >
                {item.icon}
                <span className='ml-2'>{item.label}</span>
              </Link>
            ))}
          </StyledDropdownMenu>
        </div>
      </Drawer>
    </>
  );
}
